import { render, staticRenderFns } from "./tipsBox.vue?vue&type=template&id=d0ad96bc&scoped=true&"
import script from "./tipsBox.vue?vue&type=script&lang=js&"
export * from "./tipsBox.vue?vue&type=script&lang=js&"
import style0 from "./tipsBox.vue?vue&type=style&index=0&id=d0ad96bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ad96bc",
  null
  
)

component.options.__file = "tipsBox.vue"
export default component.exports